import { render, staticRenderFns } from "./SamplesNav.vue?vue&type=template&id=96baf64c&scoped=true&"
import script from "./SamplesNav.vue?vue&type=script&lang=ts&"
export * from "./SamplesNav.vue?vue&type=script&lang=ts&"
import style0 from "./SamplesNav.vue?vue&type=style&index=0&id=96baf64c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.8_4b1a8e7b0323687afa589ac3884e675c/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96baf64c",
  null
  
)

export default component.exports